import { render } from "./commentFrequencyModal.vue?vue&type=template&id=8bdb8c58&scoped=true"
import script from "./commentFrequencyModal.vue?vue&type=script&lang=js"
export * from "./commentFrequencyModal.vue?vue&type=script&lang=js"

import "./commentFrequencyModal.vue?vue&type=style&index=0&id=8bdb8c58&lang=scss&scoped=true"

import exportComponent from "D:\\web-master\\TikTokWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bdb8c58"]])

export default __exports__